import React from 'react';

import { Box, Text, StyledOcticon } from '@primer/components'
import { IssueOpened, Check } from '@primer/octicons-react'

import Advice from '../Advice'
import FormButton from './FormButton'
import { groupMessagesByMessageId as groupMessages } from '../../helpers'


export default function(props) {
  const report = groupMessages(props.messages)
  const Icon = props.messages.length > 0 ? IssueOpened : Check
  const word = props.messages.length === 1 ? 'issue' : 'issues'
  const label =  props.messages.length > 0 ? `${props.messages.length} ${word} found` : 'No issues found'

  return (
    <Box as="span" style={{verticalAlign: 'middle'}} className="f4">
      <StyledOcticon icon={Icon} size={20} marginRight={'6px'} marginLeft={'10px'}/>
      <Text>{label}</Text>
      { props.messages.length > 0 && (
        <Box className="mt-2  ">
          <ul>{
            report.map(([messageId, items], i) => (
              <Advice
                items={items}
                messageId={messageId}
                style={{borderTop: 'none'}}
                defaultOpen={false}
                showInstallPrompt={false}
                showDiff={true}
                showLink={false}
                showHeaderCount={true}
              />
            ))
          }
          </ul>
          <FormButton
            onClick={props.onFixClick}
            disabled={props.disabled}
            secondary={props.disabled}
            isInProgress={props.isInProgress}
            label={'Fix it for me'}
          />
        </Box>
      )}
    </Box>
  )
}